var map = {
	"./404-error.svg": "3c46",
	"./500-error.svg": "0dc1",
	"./axelerate-logo-purple.svg": "c63e",
	"./axelerate-logo-white.svg": "7024",
	"./generic-empty-state.svg": "1aaf",
	"./global-board/icons/apply-icon.svg": "bf35",
	"./global-board/icons/briefcase.svg": "d585",
	"./global-board/icons/chevron.svg": "3177",
	"./global-board/icons/edit.svg": "6ade",
	"./global-board/icons/foward-arrow.svg": "8a9b",
	"./global-board/icons/info.svg": "648a",
	"./global-board/icons/money-white.svg": "8fd8",
	"./global-board/icons/money.svg": "1cde",
	"./global-board/icons/pin-gray.svg": "5e9f",
	"./global-board/icons/pin.svg": "0a33",
	"./global-board/icons/search-gray.svg": "d27e",
	"./global-board/icons/timer-white.svg": "dd17",
	"./global-board/icons/timer.svg": "54bd",
	"./global-board/icons/upload.svg": "22b8",
	"./global-board/images/background-placeholder.svg": "8b98",
	"./global-board/images/empty-placeholder.svg": "882b",
	"./global-board/images/logo-placeholder.svg": "a589",
	"./global-board/images/success-image.svg": "3913",
	"./home-icons/sourcing.svg": "f6d1",
	"./home-icons/workforce.svg": "7112",
	"./icons/back-arrow-primary.svg": "15f0",
	"./icons/chevron-forward-white.svg": "8c35",
	"./icons/close.svg": "8b1b",
	"./icons/more.svg": "0f4c",
	"./icons/search.svg": "d103",
	"./ilustration-forgot.svg": "e3cc",
	"./ilustration-sent.svg": "3a4a",
	"./navbar-icons/dollar.svg": "b191",
	"./navbar-icons/dribbble.svg": "b004",
	"./navbar-icons/filled-person.svg": "e7f1",
	"./navbar-icons/grey-arrow.svg": "42ac",
	"./navbar-icons/home-normal.svg": "85a4",
	"./navbar-icons/home-selected.svg": "ac10",
	"./navbar-icons/home.svg": "677e",
	"./navbar-icons/logout.svg": "70e6",
	"./navbar-icons/search.svg": "2d96",
	"./navbar-icons/search_selected.svg": "ac93",
	"./navbar-icons/settings.svg": "30b1",
	"./navbar-icons/source.svg": "21e0",
	"./navbar-icons/user-selected.svg": "54bc",
	"./navbar-icons/user.svg": "5928",
	"./new-axelerate-logo.svg": "b8906",
	"./product_symbol.svg": "ed51",
	"./sourcing_admin.svg": "7e28",
	"./svgs/ach.svg": "2c82",
	"./svgs/amex.svg": "e65f",
	"./svgs/generic.svg": "23f6",
	"./svgs/google.svg": "41d6",
	"./svgs/gray_arrow.svg": "f7cc",
	"./svgs/mastercard.svg": "681e",
	"./svgs/microsoft.svg": "5f93",
	"./svgs/visa.svg": "e3c0",
	"./upgrade.svg": "7d5e",
	"./workforce_admin.svg": "1386"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";